export const environment = {
  production: true,
  baseHref: 'https://www.ifa.com/', // Base path for production  
  googleReCaptchaKey: '6Lc6NCIUAAAAAJZAhAoxrZ5xcba-4xpube3avZtj'
};
